import AdvantagesItem from "./advantages-item";
export default AdvantagesItem;